export const LOCAL_STORAGE_USUARIO = 'usuario';
export const getUsuarioLocalStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_USUARIO));
  } catch (error) {
    return undefined;
  }
};
export const removeUsuarioLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_USUARIO);
  } catch (error) {
    return undefined;
  }
};
export const LOCAL_STORAGE_TOKEN = 'token';
export const getTokenLocalStorage = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_TOKEN);
  } catch (error) {
    return undefined;
  }
};
export const removeTokenLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN);
  } catch (error) {
    return undefined;
  }
};
export const getPerfilLocalStorage = () => {
  try {
    return localStorage.getItem('perfil');
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_IMPRESSORA_ETIQUETA = 'impressoraEtiqueta';
export const getImpressoraDefault = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_IMPRESSORA_ETIQUETA);
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_IMPRESSORA_LAUDO = 'impressoraLaudo';
export const getImpressoraLaudoDefault = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_IMPRESSORA_LAUDO);
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_TEXTO_LAUDO = 'rtf';

export const setTextoLaudoNoLocalStorage = (texto) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_TEXTO_LAUDO, texto);
  } catch (error) {
    return undefined;
  }
};

export const getTextoLaudoNoLocalStorage = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_TEXTO_LAUDO);
  } catch (error) {
    return undefined;
  }
};

export const removeTextoLaudoNoLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_TEXTO_LAUDO);
  } catch (error) {
    return undefined;
  }
};

export const getTextoLaudoAutoSave = (chave) => {
  try {
    return localStorage.getItem(chave);
  } catch (error) {
    return undefined;
  }
};

export const removerTextoLaudoAutoSave = (chave) => {
  try {
    localStorage.removeItem(chave);
  } catch (error) {
    return undefined;
  }
};

export const adicionarTextoLaudoAutoSave = (chave, valor) => {
  try {
    localStorage.setItem(chave, valor);
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_TEXTO_LAUDO_PLAINTEXT = 'plaintext';

export const setTextoLaudoPlainTextNoLocalStorage = (texto) => {
  try {
    console.log('RTFTEXTINCUINDOOOLD', texto);
    localStorage.setItem(LOCAL_STORAGE_TEXTO_LAUDO_PLAINTEXT, texto);
  } catch (error) {
    return undefined;
  }
};

export const getTextoLaudoPlainTextNoLocalStorage = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_TEXTO_LAUDO_PLAINTEXT);
  } catch (error) {
    return undefined;
  }
};

export const removeTextoLaudoPlainTextNoLocalStorage = () => {
  try {
    console.log('RTFTEXTREMOVENDOOLD');
    localStorage.removeItem(LOCAL_STORAGE_TEXTO_LAUDO_PLAINTEXT);
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_URL_EDITOR = 'url_editor';
export const setUrlEditor = (texto) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_URL_EDITOR, texto);
    console.log('setting editor url', texto)
  } catch (error) {
    return undefined;
  }
};

export const getUrlEditor = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_URL_EDITOR);
  } catch (error) {
    return undefined;
  }
};

export const removeUrlEditorLocalStorage = () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_URL_EDITOR);
  } catch (error) {
    return undefined;
  }
};

export const LOCAL_STORAGE_FONTE_PADRAO = 'fonte_padrao';
export const setFontePadrao = (texto) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_FONTE_PADRAO, texto);
    console.log('setting fontepadrao', texto)
  } catch (error) {
    return undefined;
  }
};

export const getFontePadrao = () => {
  try {
    return localStorage.getItem(LOCAL_STORAGE_FONTE_PADRAO);
  } catch (error) {
    return undefined;
  }
};

export const ORDENACAO_KANBAN = 'ordenacao_kanban';
export const getOrdenacaoKanban = () => {
  try {
    const value =  localStorage.getItem(ORDENACAO_KANBAN);
    if (value === null || value === undefined){
      return false
    }
    return value;
  } catch (error) {
    return false;
  }
};

export const setOrdenacaoKanban = (sortAsc) => {
  try {
    return localStorage.setItem(ORDENACAO_KANBAN, sortAsc);
  } catch (error) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/localStorage.util.js